import React, { useState, useEffect, useRef } from "react";
import { withRouter, Link } from "react-router-dom";
import imageCompression from "browser-image-compression";
import Modal from "react-modal";
import moment from "moment";
import * as faceapi from "@vladmandic/face-api/dist/face-api.esm.js";
import { useTranslation } from "react-i18next";
import Spinner from "../../components/SpringLoader/index";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import AlertService from "../../components/SweetAlert";
import { CloseButton } from "@mantine/core";
import placeholderImage from "../../assets/images/placeholder.jpg";

import { config } from "../../config/index";
import { POST, GET, PUT, newFetch } from "../../helpers/fetch";

const { SERVER_URL } = config;

const EditProfile = ({ client, sites, activeSite, history }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const client_id = user.site_associates[0].site.client_id;
  const site_id = user.site_associates[0].site_id;
  const [associate, setAssociate] = useState(null);
  const [faceVerificationInterval, setFaceVerificationInterval] = useState();
  const [faceVerificationInterval2, setFaceVerificationInterval2] = useState();
  const [counter, setCounter] = useState(0);
  const [isWebcamOn, setIsWebcamOn] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [facedescriptor, setFaceDescriptor] = useState(null);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  // const videoHeight = 290;
  // const videoWidth = 400;
  const videoHeight = 290;
  const videoWidth = 290;
  let videoRef = useRef(null);
  let photoRef = useRef(null);
  const [showModalFaceVerification, setShowModalFaceVerification] =
    useState(false);
  const padding2 = 120; // adjust this to your needs
  let height2 = 295 + padding2;
  let heightPx2 = height2 + "px";
  let heightOffset2 = height2 / 2;
  let offsetPx2 = heightOffset2 + "px";
  const [initializing, setInitializing] = useState(false);
  const [capturePhoto, setCapturePhoto] = useState(false);

  const style2 = {
    border: "0",
    borderRadius: "20px",
    bottom: "auto",
    height: heightPx2, // set height
    left: "50%",
    padding: "2rem 1rem",
    position: "fixed",
    right: "auto",
    top: "40%", // start from center
    transform: "translate(-50%,-" + offsetPx2 + ")", // adjust top "up" based on height
    width: "90%",
    overflow: "hidden",
    maxWidth: "420px",
  };

  const closeModal = async () => {
    if (isWebcamOn) {
      await clearInterval(faceVerificationInterval);
      await clearInterval(faceVerificationInterval2);
      if (videoRef.current && videoRef.current.srcObject) {
        await videoRef.current.srcObject.getVideoTracks().forEach((track) => {
          track.stop();
          videoRef.current.srcObject.removeTrack(track);
        });
      }
      await setShowModalFaceVerification(false);
      setIsWebcamOn(false);
    }
    setIsloading(false);
  };

  const fetchUser = async () => {
    let api_path = "/associate/aboutme";
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setAssociate(response.data);
      setPhoto(
        response.data.image ? `${SERVER_URL}/${response.data.image}` : null
      );

      if (user.image !== response.data.image) {
        user["image"] = response.data.image;
        localStorage.setItem("user", JSON.stringify(user));
      }

      if (response.data.facedescriptor.length > 0) {
        setFaceDescriptor(response.data.facedescriptor[0]);
      }

      setFirstName(response.data.first_name);
      setLastName(response.data.last_name);
      setEmail(response.data.email);
    }
  };

  const getUserCamera = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      ToastUtil.error("Requested device not found.");
      return false;
    }

    await navigator.mediaDevices
      .getUserMedia({
        video: true,
      })
      .then((stream) => {
        let video = videoRef.current;
        video.srcObject = stream;
        setIsWebcamOn(true);
        video.play().catch((error) => {
          console.error(error);
        });
      });
  };

  const handleOpenModalFaceVerification = () => {
    getUserCamera();
    setShowModalFaceVerification(true);
  };

  const handleVideoOnPlay = () => {
    let verifyFace2 = setInterval(async () => {
      if (!initializing) {
        photoRef.current.innerHTML = faceapi.createCanvasFromMedia(
          videoRef.current
        );
        const displaySize = {
          width: camWidth,
          height: videoHeight,
        };

        if (photoRef.current != null) {
          faceapi.matchDimensions(photoRef.current, displaySize);

          const detections = await faceapi
            .detectSingleFace(
              videoRef.current,
              new faceapi.TinyFaceDetectorOptions({
                inputSize: 160,
                scoreThreshold: 0.8,
              })
              //new faceapi.TinyFaceDetectorOptions({inputSize: 128, scoreThreshold: 0.8})
              //new faceapi.SsdMobilenetv1Options({minConfidence: 0.95, maxResults: 1})
            )
            .withFaceLandmarks()
            .withFaceDescriptor();
          if (detections && showModalFaceVerification == true) {
            setCapturePhoto(true);

            const resizedDetections = faceapi.resizeResults(
              detections,
              displaySize
            );
            const t0 = performance.now();
            const t1 = performance.now();
            if (photoRef.current != null && !initializing && resizedDetections) {
              photoRef.current
                .getContext("2d")
                .clearRect(0, 0, camWidth, videoHeight);

              // draw a custom box //
              const box = {
                x: resizedDetections.detection.box.x + 10,
                y: resizedDetections.detection.box.y,
                width: resizedDetections.detection.box.width - 25,
                height: resizedDetections.detection.box.height,
              };
              const drawOptions = {
                lineWidth: 2,
              };

              const drawBox = new faceapi.draw.DrawBox(box, drawOptions);
              drawBox.draw(photoRef.current);
              // let landmarkPositions = resizedDetections.landmarks.positions
              // let ctx = photoRef.current.getContext("2d")

              // // looping over landmarks to draw the canvas //
              // for (let i = 0; i < landmarkPositions.length; i++) {
              //   let x_val = landmarkPositions[i]._x
              //   let y_val = landmarkPositions[i]._y
              //   ctx.beginPath()
              //   ctx.arc(x_val, y_val, 1, 0, Math.PI * 2, false)
              //   ctx.fillStyle = "#CECCCB"
              //   ctx.fill()
              //   ctx.closePath()
              // }
            }
          }
        }
      }
    }, 200);

    setFaceVerificationInterval2(verifyFace2);
  };

  const takePic = async () => {
    setIsloading(true);

    let verifyFace = setInterval(async () => {
      photoRef.current.innerHTML = faceapi.createCanvasFromMedia(
        videoRef.current
      );
      const displaySize = {
        width: camWidth,
        height: videoHeight,
      };

      if (photoRef.current != null) {
        const detections = await faceapi
          .detectSingleFace(
            videoRef.current,
            new faceapi.TinyFaceDetectorOptions({
              inputSize: 160,
              scoreThreshold: 0.8,
            })
          )
          .withFaceLandmarks()
          .withFaceDescriptor();
        if (detections && showModalFaceVerification == true) {
          const resizedDetections = faceapi.resizeResults(
            detections,
            displaySize
          );

          if (photoRef.current != undefined) {
            photoRef.current
              .getContext("2d")
              .clearRect(0, 0, camWidth, videoHeight);

            // Draw a custom box
            const box = {
              x: resizedDetections.detection.box.x,
              y: resizedDetections.detection.box.y,
              width: resizedDetections.detection.box.width,
              height: resizedDetections.detection.box.height,
            };
            const drawOptions = {
              // label: 'name',
              lineWidth: 2,
            };
            const drawBox = new faceapi.draw.DrawBox(box, drawOptions);
            drawBox.draw(photoRef.current);
            // let landmarkPositions = resizedDetections.landmarks.positions;
            // let ctx = photoRef.current.getContext("2d");

            // //looping over landmarks to draw the canvas
            // for (let i = 0; i < landmarkPositions.length; i++) {
            //   let x_val = landmarkPositions[i]._x;
            //   let y_val = landmarkPositions[i]._y;
            //   ctx.beginPath();
            //   ctx.arc(x_val, y_val, 1, 0, Math.PI * 2, false);
            //   ctx.fillStyle = "#CECCCB";
            //   ctx.fill();
            //   ctx.closePath();
            // }

            let ctx2 = photoRef.current.getContext("2d");
            let img = new Image();
            ctx2.drawImage(videoRef.current, 0, 0, camWidth, videoHeight);
            img.src = photoRef.current.toDataURL("image/jpeg");

            let unixTimestamp = moment().format("X");
            const blob = await (await fetch(img.src)).blob();
            const compressed = new File(
              [blob],
              `profile_img-${unixTimestamp}.jpg`
            );

            clearInterval(verifyFace);
            closeModal();
            submitPhoto(compressed, img.src, detections.descriptor);
            setCounter(0);
          }
        }
      }
      setCounter((prevCount) => prevCount + 1);
    }, 200);

    setFaceVerificationInterval(verifyFace);
  };

  const submitPhoto = async (file, newImg, imgDescriptor) => {
    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to upload your photo?"
      )
    ) {
      if (file && imgDescriptor) {
        setPhoto(newImg);
        let formData = new FormData();
        formData.append("file", file);
        let upload_path = `/associate/upload-profile-image/client/${client_id}/site/${site_id}`;
        let upload_response = await newFetch(
          PUT,
          upload_path,
          formData,
          "form"
        );

        if (upload_response.success) {
          if (imgDescriptor) {
            let desc = JSON.stringify(Array.from(imgDescriptor));
            let api_path = `/associate/create/descriptor`;
            await newFetch(POST, api_path, {
              associate_id: user.id,
              site_id: site_id,
              descriptor: desc,
            });
          }

          ToastUtil.success(upload_response.message);
          history.push("/profile");
        }
      }
    }
  };

  useEffect(() => {
    if (user) {
      fetchUser();
    }

    const loadModels = async () => {
      const MODEL_URL = process.env.PUBLIC_URL + "/models";
      Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
        faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
        faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
      ]);
    };

    loadModels();

    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const handleWindowSizeChange = () => {
    setDeviceWidth(window.innerWidth);
  };

  const isMobile = deviceWidth <= 640;
  const camWidth = isMobile ? videoWidth : 389;
  const [photo, setPhoto] = useState(`${SERVER_URL}/${user.image}`);
  const [firstName, setFirstName] = useState(user.first_name);
  const [lastName, setLastName] = useState(user.last_name);
  const [employeeNo] = useState(user.employee_no);
  const [email, setEmail] = useState(user.email);
  const [file, setFile] = useState(null);

  const photoHandler = async (e) => {
    var file = e.target.files[0];

    var options = {
      maxSizeMB: 2,
      onProgress: Function,
      maxWidthOrHeight: 1080,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const compressed = new File([compressedFile], file.name);
      setFile(compressed);
      let reader = new FileReader();
      reader.readAsDataURL(compressed);

      reader.onload = () => {
        setPhoto(reader.result);
      };

      reader.onerror = function (error) {
        ToastUtil.error(error);
      };
    } catch (err) {
      console.log(err);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!firstName) {
      ToastUtil.error("Please enter First Name");
      return false;
    }
    if (!lastName) {
      ToastUtil.error("Please enter Last Name");
      return false;
    }
    if (!email) {
      ToastUtil.error("Please enter Email");
      return false;
    }

    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to update your profile?"
      )
    ) {
      const data = {
        // first_name: firstName,
        // last_name: lastName,
        // email: email,
      };

      let api_path = "/associate/profile/update";
      let response = await newFetch(PUT, api_path, data);

      ToastUtil.success(response.message);
      response.success && history.push("/profile");
    }
  };

  return (
    <React.Fragment>
      <form
        className="container py-3 d-flex align-items-center d-flex flex-column"
        onSubmit={(e) => submitHandler(e)}
      >
        <div>
          <img
            className="img-responsive rounded-circle border"
            style={{ height: "100px", width: "100px" }}
            src={photo ? photo : placeholderImage}
            alt="user-profile"
            id="baseImg"
          />
        </div>
        <div className="mt-2">
          {/* {facedescriptor &&
          moment(facedescriptor.createdAt, "YYYY-MM-DD").isSameOrAfter(
            moment().subtract(6, "months").format("YYYY-MM-DD")
          ) ? (
            ""
          ) : ( */}
          <Link to="#" onClick={() => handleOpenModalFaceVerification()}>
            {" "}
            {t('Change')}{" "}
          </Link>
          {/* )} */}

          {/* // ) : (
        //   <> 
            <input
        //       id="uploadPhoto"
        //       type="file"
        //       hidden
        //       onChange={(e) => photoHandler(e)}
        //     />
        //     <Link
        //       to="#"
        //       onClick={() => document.getElementById("uploadPhoto").click()}
        //     >
        //       {" "}Change{" "}
        //     </Link>
        //   </>
        // )}
        */}
        </div>
        <div className="form-group w-100 mt-4">
          <label htmlFor="firstName">{t('First Name')}</label>
          <input
            type="text"
            className="form-control"
            id="firstName"
            placeholder="Enter First Name"
            value={firstName}
            disabled
            //   onChange={e => setFirstName(e.target.value)}
          />
        </div>
        <div className="form-group w-100">
          <label htmlFor="lastName">{t('Last Name')}</label>
          <input
            type="text"
            className="form-control"
            id="lastName"
            placeholder="Enter Last Name"
            value={lastName}
            disabled
            //   onChange={e => setLastName(e.target.value)}
          />
        </div>
        <div className="form-group w-100">
          <label htmlFor="employeeNo">{t('Employee No')}</label>
          <input
            type="text"
            className="form-control"
            id="employeeNo"
            value={employeeNo}
            disabled
          />
        </div>
        <div className="form-group w-100">
          <label htmlFor="email">{t('Email')}</label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="Enter Email"
            value={email}
            disabled
          />
        </div>
        {sites && !sites[0]?.enable_face_recognition ? (
          <div className="w-100" style={{ display: "none" }}>
            <button className="btn btn-design btn-block btn-brand">
              {t('Save Changes')}
            </button>
          </div>
        ) : (
          ""
        )}
      </form>

      <Modal
        ariaHideApp={false}
        isOpen={showModalFaceVerification}
        customStyle={style2}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={true}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 9999 },
          content: style2,
        }}
      >
        <CloseButton
          title="Close"
          size="sm"
          iconSize={20}
          onClick={() => closeModal()}
          style={{ position: "absolute", top: "6px", right: "11px" }}
        />
        <div className="d-flex flex-column h-100">
          <div className="d-flex justify-content-center profile">
            <video
              id="stream"
              playsInline
              ref={videoRef}
              onPlay={handleVideoOnPlay}
              width="389"
              height="290"
            ></video>
            <canvas
              id="capture"
              width={camWidth}
              height="290"
              ref={photoRef}
              className="position-absolute"
            ></canvas>
            {isloading ? <Spinner></Spinner> : ""}
          </div>
          <div className="d-flex justify-content-center mt-auto pt-3">
            <span>
              {isloading ? (
                <strong>{t('Capturing photo, please do not move')}</strong>
              ) : capturePhoto ? (
                <button
                  //id="btn-start"
                  onClick={takePic}
                  //type="button"
                  className="btn btn-brand btn-block"
                  style={{ width: "100%" }}
                >
                  {t('Take Photo')}
                </button>
              ) : (
                <strong>
                  {t('Initialize')} {t('Please move your face closer to the screen')}
                </strong>
              )}
            </span>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(EditProfile);
